module.exports = __webpack_public_path__ + "img/horizontal_6_2_5012.3cb7437a.png";